import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=7cd1775a&scoped=true&"
import script from "./Instagram.vue?vue&type=script&lang=js&"
export * from "./Instagram.vue?vue&type=script&lang=js&"
import style0 from "./Instagram.vue?vue&type=style&index=0&id=7cd1775a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1775a",
  null
  
)

export default component.exports